module.exports = __webpack_public_path__ + "img/id-card-front.007e43b6.png";